const data = {
  state: {
      skip: 0,
      take: 10,
      filter: {
          logic: 'and' as 'and',
          filters: []
      },
      group: []
  },
  columnsConfig: [
    { field: 'label', title: 'Statut session' },
    { field: 'reference', title: 'Référence' },
    { field: 'reference_interne', title: 'Référence interne', hidden: true },
    { field: 'cloture_intervenant', title: 'Clôture intervenant' },
    { field: 'reference_produit', title: 'Référence produit', hidden: true },
    { field: 'code_produit', title: 'Code produit', hidden: true },
    { field: 'produit_libelle', title: 'Produit' },
    { field: 'modalite_libelle', title: 'Modalité', hidden: true },
    { field: 'responsable_administratif', title: 'Responsable administratif' },
    { field: 'responsable_commercial', title: 'Responsable commercial', hidden: true },
    { 
        field: 'j1', 
        title: 'J1',
        filter: "numeric",
        format: "{0:dd/MM/yyyy}" 
    },
    { field: 'nb_jour_j1', title: 'Nombre de jour avant J1', hidden: true },
    { 
        field: 'jdernier', 
        title: 'J dernier',
        filter: "numeric",
        format: "{0:dd/MM/yyyy}", 
        hidden: true
    },
    { field: 'nb_jours_jdernier', title: 'Nombre de jours depuis le dernier jour', hidden: true },
    { field: 'client_commanditaire', title: 'Client commanditaire', hidden: true },
    { field: 'client_beneficiaire', title: 'Client bénéficiaire' },
    { field: 'code_postale', title: 'Code postal de la session', hidden: true },
    { field: 'ville', title: 'Ville de la session' },
    { field: 'inter_intra', title: 'Inter/Intra', hidden: true },
    { field: 'apprenant_inscrit', title: 'Apprenants inscrits', hidden: true },
    {
        field: "edit_button",
        title: "",
        class: "center",
        width: 100,
        filterable: false
      }
  ]
};

export default data;